export default (eventType, actType, loginErrorType, path, option) => {
  return {
    event: eventType, // Dinamic Data
    actionType: actType, // Dynamic Data
    loginErrorType: loginErrorType, // Dynamic Data
    sectionName: path, // Dynamic Data
    loginButton: option, // Dynamic Data
  };
};
